/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Stringcontainsoraspect12Inputs */



/**

* @param {_Filter_Class_Stringcontainsoraspect12Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_stringcontainsoraspect12 = /** @type {((inputs?: _Filter_Class_Stringcontainsoraspect12Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Stringcontainsoraspect12Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("beinhaltet eins von")
});
export { _filter_class_stringcontainsoraspect12 as "_filter_class_StringCONTAINSORAspect" }